export const ENUM__local_event = {
  RESPONSE_ERROR_RECEIVED: 'RESPONSE_ERROR_RECEIVED',
  RESPONSE_LOW_BALANCE_RECEIVED: 'RESPONSE_LOW_BALANCE_RECEIVED',
  RESPONSE_VIEWER_ACTION_RECEIVED: 'RESPONSE_VIEWER_ACTION_RECEIVED',

  USER_AUTH_FAILED: 'USER_AUTH_FAILED',
};
